import { withStyles } from '@material-ui/core';

import ToolbarSelect from './component';
import Styles from './styles';

export default withStyles(Styles)(ToolbarSelect);
